import { DateLimitsProvider } from '../DateLimitsProvider'
import { DateLocaleProvider } from '../DateLocaleProvider'
import { TimeZoneProvider } from '../TimeZoneProvider'

function DateTimeProvider({ children, language, timeZone }) {
  return (
    <DateLocaleProvider language={language}>
      <TimeZoneProvider timeZone={timeZone}>
        <DateLimitsProvider>{children}</DateLimitsProvider>
      </TimeZoneProvider>
    </DateLocaleProvider>
  )
}

export default DateTimeProvider
